export default "__VITE_ASSET__DjGS1z0l__"